import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';

import { history, configureStore } from 'v1/stores/configureStore';

import * as route from 'v1/constants/pathnames';

const propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  refs: PropTypes.objectOf(PropTypes.any),
  state: PropTypes.objectOf(PropTypes.any),
};

const defaultProps = {
  config: undefined,
  refs: undefined,
  state: undefined,
};

function App(props) {
  const { refs, state } = props;
  const store = configureStore(state);

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path={route.rootPath} exact component={(p) => <Home {...p} {...refs} />} />
        </Switch>
      </ConnectedRouter>
    </Provider>
  );
}

App.propTypes = propTypes;
App.defaultProps = defaultProps;

export default App;
